import React from 'react';
import PropTypes from 'prop-types';
import SearchableSelect from '../../../components/ui/SearchableSelect/SearchableSelect';
import { SELECT_MODE } from '../../../components/ui/SearchableSelect/constants';

export default function UserProfileSearchableSelect({
  options = [],
  value,
  onChange,
  loading = false,
  onLoadMore,
  disabled = false,
  error = false,
  errorMessage = '',
  label = 'Assign Profile',
  placeholder = 'Select profile',
}) {
  return (
    <SearchableSelect
      mode={SELECT_MODE.INFINITE}
      options={options}
      value={value}
      onChange={onChange}
      label={label}
      labelKey="name"
      valueKey="id"
      loading={loading}
      disabled={disabled}
      error={error}
      helperText={errorMessage}
      onLoadMore={onLoadMore}
      placeholder={placeholder}
    />
  );
}

UserProfileSearchableSelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  onLoadMore: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.string,
};
